export default __webpack_public_path__ + "static/27e6caa5a8df84ca5693cbdde4ac502b.png";